import { tsRestClient } from "@api/tsRest";

import { ContactsSortRulesType } from "@interfaces/contact.type";

interface IContactFilter {
  hasVerifiedEmail?: boolean;
  jobTitles?: string[];
  keywords?: string[];
  locations?: string[];
  page?: number;
  pageSize?: number;
}

export const getContacts = async (companyIds: string[], filters: IContactFilter) => {
  const { body, status } = await tsRestClient.contacts.getContactsByCompanyIds({
    body: {
      companyIds,
      ...filters,
    },
  });

  if (status !== 200) {
    throw new Error("Failed to get contacts");
  }

  return body;
};

export const getContactRules = async () => {
  const { body, status } = await tsRestClient.contactRules.getContactRules();

  if (status !== 200) {
    throw new Error("Failed to get contact rules");
  }

  return body;
};

export const updateContactRules = async (scoringRules: ContactsSortRulesType) => {
  const { body, status } = await tsRestClient.contactRules.updateContactRules({ body: scoringRules });

  if (status !== 200) {
    throw new Error("Failed to update contact rules");
  }

  return body;
};
